import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
} from "@angular/core";
import {
  Router,
  NavigationEnd,
  RouterLinkActive,
  RouterLink,
} from "@angular/router";
import {Subscription} from "rxjs";
import {User} from "src/app/modules/auth/models/User";
import {ModalService} from "src/app/modules/core/services/modal.service";
import {NgClass} from "@angular/common";
import {ModalComponent} from "../../modules/core/components/modal/modal.component";
import {MyWorksNavComponent} from "../my-works-nav/my-works-nav.component";
import {TranslateModule} from "@ngx-translate/core";
import {
  LISTS_ACTIVE_PREFIXES,
  MOBILE_EXPLORER_ACTIVE_PREFIXES,
} from "../navigation/navigation-items.constants";

@Component({
  selector: "app-navbar-mobile",
  templateUrl: "./navbar-mobile.component.html",
  styleUrls: ["./navbar-mobile.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterLinkActive,
    RouterLink,
    NgClass,
    ModalComponent,
    MyWorksNavComponent,
    TranslateModule,
  ],
})
export class NavbarMobileComponent implements OnDestroy {
  @Input() user?: User;
  public isWorkRoute = false;
  private readonly explorerActivePrefixes = MOBILE_EXPLORER_ACTIVE_PREFIXES;
  private readonly listsActivePrefixes = LISTS_ACTIVE_PREFIXES;
  private readonly subscriptions: Subscription[] = [];

  get isListsRoute(): boolean {
    return this.listsActivePrefixes.some(
      (prefix) =>
        this.router.url === prefix || this.router.url.startsWith(prefix + "/")
    );
  }

  get isDarkMode(): boolean {
    return this.user?.theme === "dark";
  }

  constructor(
    private readonly router: Router,
    public modalService: ModalService,
    private readonly cdr: ChangeDetectorRef
  ) {
    const routeSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const url = this.router.url;
        this.isWorkRoute = this.explorerActivePrefixes.some(
          (prefix) => url === prefix || url.startsWith(prefix + "/")
        );
      }
      this.cdr.markForCheck();
    });
    this.subscriptions.push(routeSubscription);
  }

  openModal(modalId: string) {
    this.modalService.openModal(modalId);
  }

  onKeyUp(event: KeyboardEvent, modalId: string): void {
    if (event.key === "Enter" || event.key === " ") {
      this.openModal(modalId);
    }
  }

  ngOnDestroy() {
    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }
}
